import * as React from 'react'
import Spinner from '../../components/Spinner'
import { Link } from 'react-router-dom'


class ManageFishRecipeScreen extends React.Component {

  componentDidMount() {
    const id = this.props.location.id
    if( id )
      this.props.getFishRecipes(id)
  }
  


  renderFishRecipes(fishRecipes, detail) {
    if( fishRecipes.length === 0 ) return <p>Obecnie nie posiadamy żadnych przepisów dla tej ryby. Ale pracujemy nad tym! Sprawdź to ponownie za kilka dni!</p>
    else return (
      <div className="list-group">
        <div className="list-group-item list-group-item-action disabled">{detail.name}: lista przepisów</div>

        { fishRecipes.map((recipe, key) => {
          return (
            <Link 
              key={key}
              className="list-group-item"
              to={{
                pathname: 'manage-fish-recipe-detail',
                recipe
              }}
            >
              <div className="row">
                <div className="col-md-3">
                  {recipe.img && <img alt="" className="img-fluid" src={ recipe.img } />}
                </div>
                <div className="col-md-9">
                  <p className="m-0">{recipe.title}</p>
                  <span className="small text-muted">Czas przygotowania: {recipe.time}</span>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    )
  }
  
  render() {
    const { fishRecipes } = this.props.fish,
          params = this.props.location

    if( fishRecipes === null ) return <Spinner style={{ marginTop: 20 }} />
    else return (
      <div>
        <Link
          className="btn btn-primary btn-sm btn-block mb-3"
          to={{
            pathname: "manage-fish-recipe-detail",
            recipe: {fishId: params.id}
          }}
        >Dodaj przepis
        </Link>
        {this.renderFishRecipes(fishRecipes, params)}
      </div>
    )
    
  }
}

export default ManageFishRecipeScreen


// WEBPACK FOOTER //
// ./src/screens/ManageFish/ManageFishRecipeScreen.js